module.exports = __webpack_public_path__ + "media/tips/01_feuilles_lignes_logo-91aef47c.png";